import { useState, useEffect, useRef } from "react";

interface TypewriterTextProps {
  text: string;
  speed?: number;
}

const TypewriterText: React.FC<TypewriterTextProps> = ({ text, speed = 100 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const indexRef = useRef(0);

  useEffect(() => {
    setDisplayedText("");
    indexRef.current = 0;

    const interval = setInterval(() => {
      setDisplayedText((prev) => {
        if (indexRef.current < text.length) {
          const updatedText = prev + text[indexRef.current];
          indexRef.current += 1;
          return updatedText;
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return <div className="mic-title">"{displayedText}"</div>;
};

export default TypewriterText;
